import React, {useState} from 'react';
import {Button} from "reactstrap5";
import useFetch from "react-fetch-hook";
import {FormattedMessage} from "react-intl";
import NotLoggedModal from "../Modals/NotLogged";
import PropTypes from "prop-types";
import StudentModal from "../Modals/Student";
import UsedTrialModal from "../Modals/UsedTrial";
import RunTrial from "../Modals/RunTrial";
import RoleTrialModal from "../Modals/RoleTrial";
import UsingTrialModal from "../Modals/UsingTrial";

const TrialButton = ({config}) => {
    const [showModal, setShowModal] = useState(false);
    const {isLoading, data} = useFetch(config.checkUrl);

    return (
        <>
            <Button color="-outline-blue" className="btn--bolder text-uppercase" disabled={isLoading} onClick={() => setShowModal(true)}>
                <FormattedMessage defaultMessage="Vyzkoušet zdarma"/>
            </Button>
            {!isLoading && showModal && !data.canUse && data.reason === 'notLogged' &&
                <NotLoggedModal afterClose={() => setShowModal(false)} link={config.addTrialUrl}/>}
            {!isLoading && showModal && !data.canUse && data.reason === 'child' &&
                <StudentModal afterClose={() => setShowModal(false)} config={config} />}
            {!isLoading && showModal && !data.canUse && data.reason === 'using' &&
                <UsingTrialModal afterClose={() => setShowModal(false)} />}
            {!isLoading && showModal && !data.canUse && data.reason === 'used' &&
                <UsedTrialModal afterClose={() => setShowModal(false)} />}
            {!isLoading && showModal && !data.canUse && data.reason === 'role' &&
                <RoleTrialModal afterClose={() => setShowModal(false)} />}
            {!isLoading && showModal && data.canUse &&
                <RunTrial afterClose={() => setShowModal(false)} link={config.addTrialUrl} productType={config.productType} />}
        </>
    );

};

TrialButton.propTypes = {
    config: PropTypes.object.isRequired
};

TrialButton.defaultProps = {}

export default TrialButton;
